import { requestApi } from './Api';

export const getReports = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/get',
    params
  });

export const getReport = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/get_one',
    params
  });

export const getCustomReports = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/custom/get',
    params
  });

export const getFavoriteReports = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/favorite/get',
    params
  });

export const updateFavoriteReport = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/favorite/update',
    params
  });

export const saveCustomReport = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/custom/create',
    params
  });

export const getCustomReport = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/custom/get_one',
    params
  });

export const deleteCustomReport = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/report/custom/delete',
    params
  });
